/* eslint-disable eqeqeq */
import { FormGroup } from 'components'
import InfoTooltip from 'components/InfoTooltip'
import { useField } from 'formik'
import React, { useEffect } from 'react'
import styled from 'styled-components'
import { colors } from 'utils'
import { RadioButtonProps } from '../types'

const S = {
    Label: styled.label<{ checked?: boolean }>`
        position: relative;
        display: flex;
        align-items: center;
        cursor: pointer;
        color: ${colors.grayTitle};
        &::before {
            content: '';
            display: inline-block;
            flex-shrink: 0;
            width: 20px;
            height: 20px;
            margin-right: 6px;
            border-radius: 50%;
            border: 2px solid ${({ checked }) => (checked ? colors.primary : colors.icon)};
        }
        &::after {
            position: absolute;
            top: 6px;
            left: 4px;
            display: inline-block;
            content: '';
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background-color: ${colors.primary};
            opacity: ${({ checked }) => (checked ? 1 : 0)};
            transition: 0.2s;
        }
    `,
    RadioButton: styled.input`
        display:none;
    `,
    FieldLabel: styled.div`
        position: relative;
        display: inline-block;
        margin-bottom: 8px;
        font-weight: 500;
        font-size: 14px;
        color: ${colors.grayTitleOpacity(0.9)};
    `,
    InfoTooltip: styled(InfoTooltip)`
        position: absolute;
        top: -2px;
        right: -34px;
    `
}

const RadioButtonField = ({
    name,
    label,
    helperText,
    isVerticalAlign,
    options,
    optionLabel = 'label',
    optionValue = 'value',
    defaultValue,
    ...props
}: RadioButtonProps) => {
    const [field,, helper] = useField({ name })
    useEffect(() => {
        if (defaultValue && !field.value) {
            helper.setValue(defaultValue)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultValue])
    return (
        <FormGroup
            controlId={`${name}-radio-button`}
            {...props}
        >
            {label && (
                <S.FieldLabel>
                    {label}
                    {helperText && <S.InfoTooltip size={22} text={helperText} />}
                </S.FieldLabel>
            )}
            <div className={isVerticalAlign ? '' : 'd-flex'}>
                {options.map((option, index) => (
                    <div className="mr-4" key={index}>
                        <S.Label
                            htmlFor={option[optionValue]}
                            checked={(field.value || defaultValue) == option[optionValue]}
                        >
                            <S.RadioButton
                                name={name}
                                type="radio"
                                value={option[optionValue]}
                                checked={field.value == option[optionValue]}
                                onChange={(e) => helper.setValue(e.target.value)}
                                id={option[optionValue]}
                            />
                            {option[optionLabel]}
                        </S.Label>
                    </div>
                ))}
            </div>

        </FormGroup>
    )
}

export default RadioButtonField
